(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  document.querySelectorAll('.travel-hub').forEach((hub) => {
    const topics = hub.querySelectorAll('[data-filter-tag], [data-filter-country], [data-filter-season]');
    const latestSection = hub.querySelector('.travel-hub__latest');
    const cardSearch = hub.querySelector('[data-filter-search]');
    const loadMoreButton = latestSection?.querySelector('[data-load-more]');
    const articleCards = latestSection ? Array.from(latestSection.querySelectorAll('.travel-hub__article-card[data-article-tags]')) : [];

    const filterState = {
      blog: '',
      tag: '',
      country: '',
      season: '',
      query: '',
      initialVisible: Number.parseInt(loadMoreButton?.dataset.initialVisible || '0', 10) || articleCards.length,
      pageSize: Number.parseInt(loadMoreButton?.dataset.pageSize || '6', 10) || 6,
      visibleLimit: Number.parseInt(loadMoreButton?.dataset.initialVisible || '0', 10) || articleCards.length,
    };

    const applyCardFilters = () => {
      if (!articleCards.length) {
        return;
      }

      let visibleCount = 0;
      articleCards.forEach((card) => {
        const tags = (card.dataset.articleTags || '').split(',').map(normalize).filter(Boolean);
        const country = normalize(card.dataset.articleCountry || '');
        const seasons = (card.dataset.articleSeasons || '').split(',').map(normalize).filter(Boolean);
        const blogHandle = normalize(card.dataset.articleBlog || '');
        const searchableText = normalize(card.dataset.articleSearch || card.textContent || '');

        const matchesTag = filterState.tag === '' || tags.includes(filterState.tag);
        const matchesCountry = filterState.country === '' || country === filterState.country;
        const seasonAliases = filterState.season === 'autumn' ? ['autumn', 'fall'] : [filterState.season];
        const matchesSeason = filterState.season === '' || seasonAliases.some((season) => seasons.includes(season));
        const matchesBlog = filterState.blog === '' || blogHandle === filterState.blog;
        const matchesQuery = filterState.query === '' || searchableText.includes(filterState.query);
        const matches = matchesTag && matchesCountry && matchesSeason && matchesBlog && matchesQuery;

        if (matches) {
          visibleCount += 1;
        }

        card.hidden = !matches || visibleCount > filterState.visibleLimit;
      });

      if (loadMoreButton) {
        loadMoreButton.hidden = visibleCount <= filterState.visibleLimit;
      }
    };

    topics.forEach((topic) => {
      topic.addEventListener('click', (event) => {
        event.preventDefault();

        const tag = normalize(topic.dataset.filterTag || '');
        const country = normalize(topic.dataset.filterCountry || '');
        const season = normalize(topic.dataset.filterSeason || '');
        const blogHandle = normalize(topic.dataset.filterBlogHandle || '');
        const target = normalize(topic.dataset.filterTarget || 'all');
        const cards =
          target === 'cards'
            ? hub.querySelectorAll('.travel-hub__article-card[data-article-tags]')
            : hub.querySelectorAll('[data-article-tags]');

        if (Object.hasOwn(topic.dataset, 'filterCountry') && articleCards.length) {
          filterState.country = country;
          filterState.visibleLimit = filterState.initialVisible;
          applyCardFilters();
        } else if (Object.hasOwn(topic.dataset, 'filterSeason') && articleCards.length) {
          filterState.season = season;
          filterState.visibleLimit = filterState.initialVisible;
          applyCardFilters();
        } else if (target === 'blogs' && articleCards.length) {
          filterState.blog = blogHandle;
          filterState.visibleLimit = filterState.initialVisible;
          applyCardFilters();
        } else if (target === 'cards' && articleCards.length) {
          filterState.tag = tag;
          filterState.visibleLimit = filterState.initialVisible;
          applyCardFilters();
        } else {
          cards.forEach((card) => {
            const tags = (card.dataset.articleTags || '').split(',').map(normalize);
            card.hidden = tag !== '' && !tags.includes(tag);
          });
        }

        const group = topic.closest('[data-filter-group]');
        const groupItems = group ? group.querySelectorAll('[data-filter-tag]') : topics;
        groupItems.forEach((item) => item.classList.toggle('is-active', item === topic));

        hub.querySelector('.travel-hub__latest')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (cardSearch && articleCards.length) {
      cardSearch.addEventListener('input', () => {
        filterState.query = normalize(cardSearch.value);
        filterState.visibleLimit = filterState.initialVisible;
        applyCardFilters();
      });
    }

    if (loadMoreButton && articleCards.length) {
      loadMoreButton.addEventListener('click', () => {
        filterState.visibleLimit += filterState.pageSize;
        applyCardFilters();
      });

      applyCardFilters();
    }
  });
})();
